var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 40,
    rx: 6,
    fill: "#2e77bb"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "55%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 15,
    fill: "#fff"
  }, "\n    AMEX\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.9b760841668d8284ef4598ec5d1a6d16.svg";
export { ForwardRef as ReactComponent };